export const ConvertData = (data) => {
  const now = new Date(data); // convert string to Date

  // Get components
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  let hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  // Convert to 12-hour system
  const ampm = hours >= 12 ? "PM | م" : "AM | ص";
  hours = hours % 12 || 12; // Convert 0 -> 12

  // Format the final string
  return `${year}-${month}-${day} ${hours.toString().padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
};
